import { cofeeSupportMail, cofeeSupportNumberDisplay } from '@constants/cofee';

import Icon from '../icon/Icon';

import theme from '../../../themes/colors';

const ContactSupport = () => (
  <div className="w-105 rounded-lg">
    <h2 className="mb-6 text-xl font-medium">Contact Support</h2>

    <div className="flex gap-1">
      <div className="size-6">
        <Icon name="headset" className="size-6 text-gray-500" />
      </div>
      <div className="mb-2 text-base font-bold">Call or WhatsApp</div>
    </div>
    <div className="text-base font-normal text-grey">
      {cofeeSupportNumberDisplay}
    </div>

    <div className="mt-6 flex gap-1">
      <div className="size-6">
        <Icon name="email" className="size-6" stroke={theme.cofeeNeutral7} />
      </div>
      <div className="mb-2 text-base font-bold">Email Id</div>
    </div>
    <div className="text-base font-normal text-grey">{cofeeSupportMail}</div>
  </div>
);

export default ContactSupport;
